<template>
	<div class="courseResource">
		<div class="coure-label-list-box">
			<div class="category-content">
				<div class="category-type category-type1 clearfix">
					<span class="category-name" :class="{'active':active===item}" @click="active=item" v-for="item in menu">
						<span class="category-text">{{item}}</span>
					</span>
				</div>
			</div>
		</div>
		<div class="list-content" style="min-height: 256px; ">
			<div class="list-wrap">
				<vue-virtual :list="showProduct()" :more="false" :itemStyle="{'padding-bottom':'30px'}"></vue-virtual>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'
	import vueVirtual from '../../../components/vue-virtual'
	import config from '../../../util/config.js'
	export default {
		data() {
			return {
				active: '',
				array: [],
				array_category_search: '',
				menu: ['药学', '护理学虚拟仿真类', '工科虚拟仿真类', '其他虚拟仿真类' ]
			}
		},
		watch: {
			$route(val) {
				const category = this.$route.params.category
				if (category != 'all') this.active = category
				else this.active = this.menu[0]
			}
		},
		methods: {
			...mapMutations(['setProducts']),
			showProduct() {
				return this.array.filter(item => item.category === this.active)
			},
			async Product() {
				const res = await this.$http.get('product/GetProduct.do')
				this.setProducts(res.data)

				res.data.forEach(item => {
					this.array.push({
						id: item.id,
						title: item.name,
						img: item.imgUrl.replace('..', config.old_file_path),
						label1: '易格',
						label2: '北京易格通智仿真',
						url: config.old_file_path + item.url,
						category: item.category
					})
				})

				const category = this.$route.params.category
				if (category != 'all') this.active = category
				else this.active = this.menu[0]
			}
		},
		created() {
			this.Product()
		},
		components: {
			vueVirtual
		}
	}
</script>

<style scoped >
	.courseResource {
		width: 1280px;
		margin: 0 auto;
	}
	
	.coure-label-list-box {
		position: relative;
		overflow: hidden;
	}
	
	.category-content {
		padding-top: 20px;
	}
	
	.clearfix {
		clear: both;
		zoom: 1;
	}
	
	.category-name {
		display: inline-block;
		height: 32px;
		padding: 0 15px;
		margin-right: 15px;
		line-height: 32px;
		margin-bottom: 20px;
		color: #fff;
		font-size: 14px;
		cursor: pointer;
		color: #2a2a2a;
	}
		
	.category-name:hover {
		color: #00aaff;
	}
		
	.category-name.active {
		color: #fff;
	}
		
	.category-name.active {
		background: #3d84ff;
		border-radius: 16px;
	}
</style>
